export default __webpack_public_path__ + "static/media/m6.618bcc75.jpg";